import { cva } from "class-variance-authority";

export const fieldSurfaceVariants = cva("", {
  variants: {
    variant: {
      filled:
        "bg-input border-border hover:border-neutral-400 dark:bg-foreground/10 dark:hover:border-neutral-500",
      outline: "bg-background border-neutral-400 dark:border-border hover-surface-control",
    },
  },
});

export const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground w-full min-w-0 rounded-lg border shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: fieldSurfaceVariants({ variant: "filled" }),
        ghost:
          "border-transparent bg-transparent shadow-none focus-visible:border-transparent focus-visible:ring-0 hover:bg-accent/20 focus-visible:bg-foreground/20 dark:hover:bg-transparent/5 dark:focus-visible:bg-foreground/5",
        outline:
          "bg-input border-border hover:border-neutral-400 dark:bg-transparent dark:hover:border-neutral-500 disabled:opacity-50",
      },
      size: {
        xs: "h-4 px-2 py-0.5 text-xs file:h-6 file:text-xs",
        sm: "h-6 px-2.5 py-0.5 text-sm file:h-6 file:text-xs",
        default: "h-9 px-3 py-1 text-base md:text-sm file:h-7 file:text-sm",
        lg: "h-10 px-4 py-2 text-base md:text-sm file:h-8 file:text-sm",
      },
      caretPosition: {
        left: "text-left",
        right: "text-right",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      caretPosition: "left",
    },
  },
);
